import BaseApi from "./BaseApi";
import { logout } from "./AuthApi";

export function getDiariesApi(data) {
  return BaseApi.get("/diaries", {
    params: data,
  });
}
export function postDiaryApi(diary) {
  return BaseApi.post("/diaries", diary);
}
export async function postImage(binaryImage, file) {
  try {
    // 1. POSTのpresigned URLを取得
    const postUrlResponse = await BaseApi.get(
      `/diaries/image/purl/${file.name}/post`
    );

    // 2. 取得したpresigned URLを使用して、binaryImageをアップロード
    const contentType = file.type;
    await fetch(postUrlResponse.data.presignedUrl, {
      method: "PUT",
      body: binaryImage,
      headers: {
        "Content-Type": contentType,
      },
    });

    // 3. GETのpresigned URLを取得
    const getUrlResponse = await BaseApi.get(
      `/diaries/image/purl/${file.name}/get`
    );

    // 4. presignedUrlからデータをフェッチしてBlobを作成
    const response = await fetch(getUrlResponse.data.presignedUrl);
    const blob = await response.blob();
    
    // 5. BlobからデータURLを生成（オブジェクトURLの代わりに）
    const reader = new FileReader();
    const dataUrl = await new Promise(resolve => {
      reader.onload = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
    
    // 6. 現在の関数と同様の戻り値を返す
    const urlData = {
      url: dataUrl, // データURLを使用
      presignedUrl: getUrlResponse.data.presignedUrl,
      objectKey: getUrlResponse.data.objectKey // objectKeyを追加
    }
    
    return urlData;
  } catch (errors) {
    console.error("Error uploading image:", errors);
    if (errors.response && errors.response.status == 401) {
      logout();
    }
    return "";
  }
}
export function getDiaryById(diaryId) {
  return BaseApi.get("/diaries/" + diaryId);
}

export function copyDiaryApi(sourceDiaryId, destDate, editor, diaryPeriod) {
  const payload = {
    sourceDiaryId: sourceDiaryId,
    destDate: destDate,
    editor: editor,
    diaryPeriod: diaryPeriod
  };
  console.log("📤 copyDiaryApi - Sending copy payload:", payload);
  return BaseApi.post("/diaries/copy", payload);
}
